module.exports = __webpack_public_path__ + "img/1978.845acb93.png";